import React from 'react';
import { Lightbulb } from 'lucide-react';
export const DaYun: React.FC = () => {
  return <div className="space-y-12" data-id="element-121">
      <div className="text-center mb-10" data-id="element-122">
        <h1 className="text-3xl font-serif font-bold text-gold-dark mb-4" data-id="element-123">
          大运排盘
        </h1>
        <p className="text-ink-light" data-id="element-124">十年一运，看人生阶段性的起伏变化。</p>
      </div>

      <div className="bg-gold/5 border border-gold/20 p-6 rounded-lg flex gap-4 items-start" data-id="element-125">
        <div className="bg-gold/20 p-2 rounded-full text-gold-dark shrink-0" data-id="element-126">
          <Lightbulb size={24} data-id="element-127" />
        </div>
        <div data-id="element-128">
          <h3 className="font-serif font-bold text-gold-dark text-lg mb-2" data-id="element-129">
            小白理解法：人生的季节
          </h3>
          <p className="text-ink-light text-sm leading-relaxed" data-id="element-130">
            <strong data-id="element-131">命局（八字）：</strong> 是一辆车，有人是奔驰，有人是拖拉机。
            <br data-id="element-132" />
            <strong data-id="element-133">大运：</strong>{' '}
            是你开的道路，十年换一条路。有时是高速公路（好运），有时是泥泞山路（差运）。
            <br data-id="element-134" />
            拖拉机走在柏油路上，也能平稳前行；奔驰开进沼泽地，也会深陷其中。这就是"命好不如运好"的道理。
          </p>
        </div>
      </div>

      <section className="bg-white ink-border p-8 rounded-lg shadow-sm text-center" data-id="element-135">
        <h2 className="text-2xl font-serif text-gold-dark mb-6" data-id="element-136">
          大运排法规则
        </h2>
        <div className="flex flex-col md:flex-row justify-center gap-8 text-left" data-id="element-137">
          <div className="bg-paper p-6 rounded-lg flex-1" data-id="element-138">
            <h3 className="font-bold text-ink mb-3 text-lg" data-id="element-139">阳男阴女：顺排</h3>
            <p className="text-ink-light text-sm" data-id="element-140">
              如果男生出生在阳年（如甲子年），或女生出生在阴年（如乙丑年），大运从出生月份顺着往下排。
              <br data-id="element-141" />
              例如月柱是丙寅，大运就是：丁卯 → 戊辰 → 己巳...
            </p>
          </div>
          <div className="bg-paper p-6 rounded-lg flex-1" data-id="element-142">
            <h3 className="font-bold text-ink mb-3 text-lg" data-id="element-143">阴男阳女：逆排</h3>
            <p className="text-ink-light text-sm" data-id="element-144">
              如果男生出生在阴年，或女生出生在阳年，大运从出生月份逆着往上排。
              <br data-id="element-145" />
              例如月柱是丙寅，大运就是：乙丑 → 甲子 → 癸亥...
            </p>
          </div>
        </div>
        <p className="mt-8 text-ink-light text-sm" data-id="element-146">
          👉 想要查看自己的大运？请前往{' '}
          <strong className="text-gold-dark" data-id="element-147">实战篇</strong> 输入生辰排盘！
        </p>
      </section>
    </div>;
};